import pdfobject from "pdfobject"
import { useEffect, useState } from "react"
import { useDispatch } from "react-redux"
import { useParams } from "react-router-dom"
import { useAppSelector } from "../../../stateManagement/hooks/redux"
import { getItemWebStorage } from "../../../features/webStorageSaver"
import { customFetchFileCUBA } from "../../../api/custom/documentsApi"
import { showToastMessage } from "../../../stateManagement/reducers"
import { Loader } from "../../loaders/Loader"

export default function CustomDocumentViewerPDF() {
    const dispatch = useDispatch()
    const { id, entityId }: any = useParams()
    const restAuthToken = useAppSelector(state => state.customAuth.customAuthToken)
    const [documentIsLoading, setDocumentIsLoading] = useState<boolean>(true)
    const currentConfig = getItemWebStorage('currentConfig')
    const { cardAdditionalItems } = currentConfig
    const cardAdditionalItem = cardAdditionalItems.find((item: any) => item?.id === id)
    const pdfViewerDivId = "document-pdf-viewer-div"

    async function getDocumentFile() {
        setDocumentIsLoading(true)
        const { restAuthRequestOptions, api, apiType } = cardAdditionalItem ?? {}
        const { downloadDocument: downloadDocumentApi } = api ?? {}
        let file
        if (apiType === "jmix") {

        } else if (apiType === "cuba") {
            file = await customFetchFileCUBA(downloadDocumentApi, restAuthToken, restAuthRequestOptions, false, entityId)
        }
        if (file) {
            if (file instanceof Blob) {
                const fileURL = URL.createObjectURL(file)
                pdfobject.embed(fileURL, `#${pdfViewerDivId}`);
            } else {
                dispatch(showToastMessage({ messageText: "Возникла ошибка при загрузке документа для просмотра", messageType: "error" }))
            }
        }
        setDocumentIsLoading(false)
    }

    useEffect(() => {
        if (restAuthToken) {
            getDocumentFile()
        }
    }, [restAuthToken, id, entityId])

    return (
        <>
            {documentIsLoading && <Loader />}
            <div id={pdfViewerDivId} />
        </>
    )
}
